import React, { useContext, useRef, useState } from "react"
import { Field, Formik, ErrorMessage } from "formik"
import Checkbox from "@material-ui/core/Checkbox"
import { scrollToTopOfCurrentStep } from "services/break"
import LegacyRetinaImage from "components/LegacyRetinaImage"
import { userContext } from "global/context/sub-contexts/userContext"
import { submit as leadGenSubmit } from "services/leadgen"
import analytics from "global/AnalyticsData"
import { getFieldByType, generateFormValidation2, generateInitialValues, POSTPayloadContructor, FormikOnChangeComponent, NexxtForm } from "./LeadGenHelpers"
import "./LeadGen3.scss"

const LeadGenStep = ({ breakId, step, terms, onEngage = function () {}, onAwardPoints = function () {}, onChangeBackground = function () {}, nextStepButton, skipButton, handleInstantWinEvent=null }) => {
  //Form status of validation/submission used as class to style things like the submit button
  const [formStatus, setFormStatus] = useState("untouched") //ENUM: ["untouched", "is-invalid", "is-valid", "submitting", "submitted"]
  //just a dumb bool to see whether we should show the thank you or not.
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [apiError, setApiError] = useState(null)
  const formRef = useRef()
  const stepFormData = step.leadGenForm
  const userProfile = useContext(userContext).getProfile()
  const initialValues = generateInitialValues(userProfile, step)
  const dynamicValidationSchema = generateFormValidation2(stepFormData)

  //absurd catfood variation
  const isBlueBuffalo = JSON.stringify(stepFormData).toLowerCase().indexOf("blue buffalo") > -1

  // some special behavior for specific campaigns :(
  // for 2 campaigns, we submit forms directly to the client
  let nexxtExtraData = null

  // nexxt-resume-national
  if (breakId && breakId === "d2506236-c42d-4f98-8f66-03a0aaecfe5d") {
    if (typeof window != "undefined") {
      console.log("in Nexxt mode for nexxt-resume-national")
    }
    nexxtExtraData = {
      FAffiliateID: "02197ACD-CA01-4632-AA60-9746121603D9",
      FSource: "H22"
    }
  }

  // nexxt-national
  if (breakId && breakId === "996f30ca-4a32-461b-89f5-340edd05ebe5") {
    if (typeof window != "undefined") {
      console.log("in Nexxt mode for nexxt-national")
    }
    nexxtExtraData = {
      FSource: "H24"
    }
  }
  
  // nexxt-resume-national-embed
  if (breakId && breakId === "7ea24659-cef3-4cee-93fc-d9505f3b176e") {
    if (typeof window != "undefined") {
      console.log("in Nexxt mode for nexxt-resume-national-embed")
    }
    nexxtExtraData = {
      FSource: "H24"
    }
  }
  

  const isNexxtCampaign = ( nexxtExtraData !== null)

  if (isBlueBuffalo) {
    delete stepFormData.fields
    //override fields with the new hotness
    stepFormData.fields = [
      { name: "firstName", required: true },
      { name: "lastName", required: true },
      { name: "email", required: true },
      { name: "zip", required: true },
      { name: "newToBlue", displayTitle: "Are you new to BLUE?", required: true },
      { name: "petName", required: true },
      { name: "petGender", required: true },
      { name: "petBirthDate", displayTitle: "Pet's Birthday", required: true },
    ]
  }

  const handleLeadGenSubmit = async values => {
    try {
      if (isBlueBuffalo) {
        console.log("This is a demo for a cat food. We don't want to annoy their server people, so we won't send them this POST.")
      } else {
        try {
          const response = await leadGenSubmit(stepFormData.id, breakId, step.id, values)

          if (isNexxtCampaign) {
            handleNexxtSubmission(formRef, stepFormData, values)
          }
    
          if (response.status === 200) {
            onEngage && onEngage()
            onAwardPoints && onAwardPoints()
      
            analytics.stepEvent("step_interaction_lead_gen_info_submission", step, {})
      
            if (typeof window !== `undefined`) {
              step.leadGenForm.confirmations.map((confirmation, index) => (
                values.confirmations[index] = confirmation
              ));
              window.dataLayer.push({
                event: "step_interaction_lead_gen_info_submission",
                form: values,
              })
            }

            setFormStatus("submitted")
            setFormSubmitted(true)
            scrollToTopOfCurrentStep(step.id)  

            const result = await response.json()
            console.log(`result`, result)
            handleInstantWinEvent && handleInstantWinEvent({eventName: `leadgen_submit`.toLowerCase(), context: {form: result, stepId: step.id}})

    
          } else {
            const responseBody = await response.json()
            setApiError(responseBody.message)
          }

        } catch (e) {
          // keep on moving if there's an API issue
          console.log(e)
        }
      }

    } catch (e) {
      console.log(e)
    }
  }

  const handleNexxtSubmission = async (formRef, stepFormData, values) => {
    formRef.current.submit()
  }
  
  return (
    <section className={`leadgen-step-3 leadgen-step form-status-${formStatus}`}>
      <div className={`step-content ${step.backgroundImage ? " with-shadow" : ""}`}>
        {formSubmitted === false && (
          <div className="leadgen-form-body-container">
            <div className="intro">
              {stepFormData.headline && <h1 dangerouslySetInnerHTML={{ __html: stepFormData.headline }} />}

              {step.headerImage && <LegacyRetinaImage image={step.headerImage} className={`leadgen-form-image`} />}
            </div>

              <Formik
                initialValues={initialValues}
                validationSchema={dynamicValidationSchema}
                validateOnBlur={false}
                validateOnChange={true}
                validateOnMount={true}
                onSubmit={async values => {
                  console.log("Leadgen form submitted!")
                  values = POSTPayloadContructor(stepFormData, values)
                  await handleLeadGenSubmit(values)

                  

                }}>
                {formik => {
                  // console.log(`formik.values`, formik.values)
                  return (
                    <>
                      <FormikOnChangeComponent formStatus={formStatus} setFormStatus={setFormStatus} stepFormData={stepFormData} />
                      <NexxtForm config={stepFormData} formik={formik} extra={nexxtExtraData} ref={formRef} />
                      <form>

                      <div className="fields">
                      { stepFormData.fields && stepFormData.fields.map((item, i) => {
                          return getFieldByType({ field: item, formik, index: i })
                        })}
                      </div>
                      <div className="confirmations">
                        {step.leadGenForm.confirmations.map((item, i) => {
                          // console.log(`item`, item)
                          return (
                            <Field name={item.id} key={i}>
                              {({ field, meta }) => {
                                return (
                                  <>
                                    <div className={`leadgen-confirmation `} key={i}>
                                      <Field type="checkbox" 
                                          // defaultChecked={item.precheck} 
                                          value={formik.values[item.id]} 
                                          component={Checkbox} 
                                          id={field.name}
                                          name={field.name} 
                                          error={formik.errors[item.id]} 
                                          touched={formik.touched[item.id] && true ? "true" : ""} 
                                          onChange={e => { console.log(`checked`, e.target.checked); formik.setFieldValue(field.name, e.target.checked)}}
                                      />
                                      <label htmlFor={field.name} dangerouslySetInnerHTML={{ __html: item.name === "legal-user-acknowledgement-confirmation" ? "*By clicking Submit I acknowledge that I have read and agree to be bound by the Breaktime Media MWH, LLC" : `${item.text}` }} />
                                    </div>
                                    {meta.error && (
                                      <span className="error">
                                        <ErrorMessage name={field.name} />
                                        <br />
                                        <br />
                                      </span>
                                    )}
                                  </>
                                )
                              }}
                            </Field>
                          )
                        })}
                      { apiError &&
                          <div style={{fontSize: "16px"}} className="error">{apiError}</div>
                      }

                      </div>
                      <button
                        type="submit"
                        onClick={e => {
                          e.preventDefault()
                          
                          formik.handleSubmit()
                        }}>
                        Submit
                      </button>
                      {terms && <span class="terms" dangerouslySetInnerHTML={{ __html: `*${terms}` }}></span>}
                      </form>
                    </>
                  )
                }}
              </Formik>
            
          </div>
        )}
        {formSubmitted === true && (
          <div className={`leadgen-form-thank-you-container thank-you`}>
            {stepFormData.thanksHeadline && <h1 dangerouslySetInnerHTML={{ __html: stepFormData.thanksHeadline }} />}

            {stepFormData.thanksDesc && <p dangerouslySetInnerHTML={{ __html: stepFormData.thanksDesc }} />}

            {stepFormData.thanksImage && <LegacyRetinaImage image={stepFormData.thanksImage} className={`leadgen-form-image`} />}
          </div>
        )}
        {skipButton}
        {nextStepButton}
      </div>
    </section>
  )
}

export default LeadGenStep
